import React from "react";
import { Provider } from "react-redux";
import { KeycloakProvider } from "@wf/keycloak-axios-provider";
// import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";

import Router from "./AppRouter";
import createStore from "../redux/createStore";
import { pathJoin } from "../utils/helpers";

import "../assets/css/index.scss";
import useColors from "../hooks/useColors";

const store = createStore();

const keycloakConfigPath = pathJoin([process.env.REACT_APP_PUBLIC_PATH, "keycloak.json"]);
const deployment = process.env?.REACT_APP_DEPLOYMENT;
const withArgocd = deployment?.toString() === "argocd" ? undefined : keycloakConfigPath;
/* const instance = createInstance({
  urlBase: "https://paylican.matomo.cloud/",
  siteId: 3
}); */
const App = () => {
  const colorsApplied = useColors();
  if (!colorsApplied) {
    return null;
  }
  return (
    <KeycloakProvider configUrl={withArgocd} trackUserActivity sessionIdleMilliseconds={1000 * 60 * 60}>
      <Provider store={store}>
        <Router />
      </Provider>
    </KeycloakProvider>
  );
};

export default App;
